import React from 'react';

import Meta from '../components/Meta';
import HeaderSection from "../components/header/HeaderSection";

const Page = () => {
  return (
    <>
      <Meta title="Terms & Conditions - The Engineering Book Club"/>
      <HeaderSection title="Terms & Conditions" subtitle="Last updated: February 2026"/>

      <section className="relative py-1 md:py-24">
        <div className="container">
          <div className="mx-auto max-w-[48.125rem]">
            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Introduction</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              By accessing and using the Engineering Book Club website (www.engineeringbookclub.com)
              and joining our community, you agree to the following terms and conditions.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Membership</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              The Engineering Book Club offers free and paid memberships. Free members get access to
              the community on Discord. Pro members get access to additional features including live
              events. You can cancel your paid membership at any time.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Payments and Refunds</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Payments for Pro memberships are processed through Stripe. We do not store any payment
              information. If you are not satisfied with the experience, you can request a refund by
              contacting us at hello@engineeringbookclub.com. No questions asked.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Community Conduct</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              All members are expected to follow our Code of Conduct and Community Guidelines. We
              reserve the right to remove any member who violates these rules without prior notice.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Content and Intellectual Property</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              The content on this website, including text, images, and logos, is owned by the Engineering
              Book Club. The books discussed in the community are the intellectual property of their
              respective authors and publishers. Members are responsible for purchasing their own copies
              of the books.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Newsletter</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              By subscribing to our newsletter, you agree to receive weekly emails from us. You can
              unsubscribe at any time using the link provided in each email.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Changes to These Terms</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We may update these terms from time to time. When we do, we will update the date at the
              top of this page. Continued use of the website and community after changes are posted
              means you accept the updated terms.
            </p>

            <h2 className="text-jacarta-700 font-display text-xl dark:text-white">Contact</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              If you have any questions about these terms, please contact us
              at hello@engineeringbookclub.com.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Page;
